import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-arlandaparkering',
    templateUrl: './arlandaparkering.component.html',
    styleUrls: ['./arlandaparkering.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArlandaparkeringComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
